import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';

export default function LoginPage() {
  const [benutzername, setBenutzername] = useState('admin');
  const [pw, setPw] = useState('');
  const [fehler, setFehler] = useState('');
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  async function login() {
    if (loading) return;
    setLoading(true);
    setFehler('');
    try {
      const r = await api.post('/login', { benutzername: benutzername.trim(), passwort: pw });
      if (r.data.forcePasswordChange) {
        nav('/admin?tab=sicherheit&first=1');
      } else {
        nav('/dashboard');
      }
    } catch {
      setFehler('Falsches Passwort');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', padding: '20px' }}>
      <div style={{ fontSize: '80px', marginBottom: '16px' }}>💰</div>
      <h1 style={{ margin: '0 0 8px', color: '#1e293b' }}>Finanz-Analyse</h1>
      <p style={{ color: '#64748b', marginBottom: '32px' }}>Wohin fließt dein Geld?</p>
      <input type="text" value={benutzername} onChange={e => setBenutzername(e.target.value)}
        autoCapitalize="none" autoCorrect="off" autoComplete="username"
        placeholder="Benutzername"
        disabled={loading}
        style={{ width: '100%', maxWidth: '300px', padding: '14px', borderRadius: '12px', border: '2px solid #e2e8f0', fontSize: '16px', marginBottom: '12px', boxSizing: 'border-box' }} />
      <input type="password" value={pw} onChange={e => setPw(e.target.value)}
        onKeyDown={e => e.key === 'Enter' && login()}
        autoComplete="current-password"
        placeholder="Passwort"
        disabled={loading}
        style={{ width: '100%', maxWidth: '300px', padding: '14px', borderRadius: '12px', border: '2px solid #e2e8f0', fontSize: '16px', marginBottom: '12px', boxSizing: 'border-box' }} />
      {fehler && <p style={{ color: '#ef4444', marginBottom: '12px' }}>{fehler}</p>}
      <button onClick={login} disabled={loading}
        style={{ width: '100%', maxWidth: '300px', padding: '14px', background: 'linear-gradient(135deg,#6366f1,#4f46e5)', color: 'white', border: 'none', borderRadius: '12px', fontSize: '16px', fontWeight: '700', cursor: loading ? 'wait' : 'pointer' }}>
        {loading ? 'Anmelden...' : 'Anmelden'}
      </button>
    </div>
  );
}
